import Swal from 'sweetalert2'
import { useStore } from "vuex";
import useAuth from './useAuth';

const useAuthPrompt = () => {
    const store = useStore()
    const { confirmTwoFactor, validateOtpPassword } = useAuth()

    async function requestAuthorization(type = 'password', pantalla = 'normal', usuario = {}) {
        let textosSwualer = {
            'otpLogin': {
                title: 'Autenticación de dos factores requerida',
                inputLabel: 'Ingrese el código OTP',
                inputType: 'text'
            },
            'otp': {
                title: 'Esta acción requiere que ingrese el código OTP',
                inputLabel: 'Código',
                inputType: 'text'
            },
            'password': {
                title: 'Esta acción requiere que ingrese su contraseña',
                inputLabel: 'Contraseña',
                inputType: 'password'
            }

        }

        let html1 = `    <input 
      id="swal-input-code"
      class="swal2-input"
      placeholder="${textosSwualer[type].inputLabel}"
      type="${textosSwualer[type].inputType}"
    >`;

        let html2 = `  <div class="form-check mt-3 text-start">
      <input 
        type="checkbox" 
        class="form-check-input" 
        id="swal-input-check"
      >
      <label class="form-check-label" for="swal-input-check">
        Es un código de recuperación
      </label>
    </div>`


        const result = await Swal.fire({
            title: textosSwualer[type].title,
            html: type.includes('otp') ? html1 + html2 : html1,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            confirmButtonText: 'Validar',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,

            preConfirm: async () => {
                const value = document.getElementById('swal-input-code').value
                const recoverCode = document.getElementById('swal-input-check').checked

                /** Validaciones */
                if (!value) {
                    Swal.showValidationMessage('Debes ingresar un valor')
                    return false
                }

                if (!recoverCode) {
                    if (type.includes('otp') && value.toString().length !== 6) {
                        Swal.showValidationMessage('Debe ser un número de 6 dígitos')
                        return false
                    }
                }

                // if (!checked && type.includes('otp')) {
                //     Swal.showValidationMessage('Debes confirmar el checkbox')
                //     return false
                // }

                Swal.isLoading()

                let resp = {}
                const formData = { type, code: value, recoverCode }
                if (pantalla === 'login') {
                    usuario.code = value
                    usuario.recoverCode = recoverCode
                    resp = await confirmTwoFactor(usuario)
                } else {
                    resp = await validateOtpPassword(formData)
                }

                const { response, data } = resp

                if (response) {
                    await Swal.fire('Autorizado', 'Validación correcta', 'success')
                    return data
                }

                Swal.showValidationMessage('Validación incorrecta')
                return false
            }
        })

        return result.isConfirmed && result.value ? result.value : false

    }

    return { requestAuthorization }
}
export default useAuthPrompt